import { components } from 'react-select';
import { useTranslation } from 'react-i18next';
import IconChecked from './icon_checked.svg';
import IconUnchecked from './icon_unchecked.svg';
import s from './index.module.scss';

export const ValueContainer = ({ children, ...props }) => {
  const { t } = useTranslation('activity');
  const values = props.getValue();
  return (
    <components.ValueContainer {...props}>
      {children}
      {!!values.length && (
        <span className="f-small-regular">
          {t('operation_type_select.selected', {
            from: values.length,
            to: props.options.length,
          })}
        </span>
      )}
    </components.ValueContainer>
  );
};

export const Option = props => {
  return (
    <components.Option {...props}>
      <img src={props.isSelected ? IconChecked : IconUnchecked} alt="icon" width={20} height={20} />
      <span className="f-small-regular">{props.label}</span>
    </components.Option>
  );
};

export const MenuList = props => {
  const { t } = useTranslation('activity');
  const current = props.getValue();
  const checked = props.options.length === current.length;

  return (
    <components.MenuList {...props}>
      <div
        className={s.all_options}
        onClick={() =>
          props.options.length === current.length
            ? props.setValue([])
            : props.setValue(props.options)
        }
      >
        <img src={checked ? IconChecked : IconUnchecked} alt="icon" width={20} height={20} />
        <span className="f-small-regular">{t('operation_type_select.all_operations')}</span>
      </div>
      {props.children}
    </components.MenuList>
  );
};
